import axios        from 'axios';
import computeLcm   from 'compute-lcm';
import cookies      from 'browser-cookies';
import EventManager from 'dd-event-manager';
import ImageManager from '../../../core/ImageManager';



const $ev = {};
const imageManager = new ImageManager();



new EventManager($ev);



const SEARCH_MAPPINGS = [
  {condition: 'screen', target: 'typeId'},
  {condition: 'type'  , target: 'classId'},
];



export default {
  namespaced: true,

  state: {
    siteId: null,
    items: [],
  },

  getters: {
    dataPath: (state, getters, rootState, rootGetters) => {
      return rootGetters['banner/config/joinedPath']('data');
    },
    jsonPath: (state, getters, rootState, rootGetters) => {
      return rootGetters['banner/config/joinedPath'](['data', 'banner.json']);
    },
    search: (state, getters, rootState, rootGetters) => async (condition = {}) => {
      let items = state.items;

      const myConditions = {};
      SEARCH_MAPPINGS.forEach(MAPPING => {
        if (condition[MAPPING.condition] !== undefined && condition[MAPPING.condition] !== null) {
          let values = condition[MAPPING.condition];
          if (typeof values === 'string') {
            values = values.replace(/\s/g, '').split(',');
          }
          myConditions[MAPPING.condition] = values;
        } else {
          myConditions[MAPPING.condition] = null;
        }
      });

      // 表示期間でふるい落す
      if (!rootGetters['banner/config/isIgnorePeriod']) {
        const forceDate = rootGetters['banner/config/forceDate'];
        const nowDate   = forceDate ? new Date(forceDate) : new Date();
        const year      = nowDate.getFullYear();
        const month     = nowDate.getMonth();
        const day       = nowDate.getDate();
        const now       = new Date(year, month, day).getTime();
        items = items.filter(item => { return now >= item._dispPeriodFrom && now <= item._dispPeriodTo });
        if (!items.length) return items;
      }

      // PC、SPのどちらかの画像、及びURLが未指定であればふるいおとす
      // ただしバナータグにメディアクエリ値の指定があれば、それだけをチェックする
      // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-136
      const mqJudgments = condition.mq ? [condition.mq] : ['pc', 'sp'];
      items = items.filter(item => {
        for (let mq of mqJudgments) {
          if (!item[`originFileName_${mq}`] || !item[`url_${mq}`]) {
            return false;
            break;
          }
        }
        return true;
      });

      // 絞り込み
      SEARCH_MAPPINGS.forEach(MAPPING => {
        if (myConditions[MAPPING.condition] !== null) {
          items = items.filter(item => {
            return myConditions[MAPPING.condition].indexOf(item[MAPPING.target]) !== -1;
          });
        }
      });

      if (!items.length) return items;

      // セグメントで絞り込み
      // (1)生徒 or 先生
      const userCategory = condition.segments.userCategory;
      items = items.filter(item => {
        if (item.segment1 === null) return true;
        if (!userCategory) return false;
        return (userCategory === 'teacher' && item.segment1 === '1' || userCategory === 'student' && item.segment1 === '2');
      });

      if (!items.length) return items;

      // (2)志望校
      const myUnivIds = condition.segments.schools;
      items = items.filter(item => {
        if (item.segment2 === null) return true;
        const univIds = item.segment2.split('|');

        for (let i = 0, l = univIds.length; i < l; i++) {
          const univId = univIds[i];
          if (myUnivIds.indexOf(univId) !== -1) {
            return true;
            break;
          }
        }
        return false;
      });

      if (!items.length) return items;

      // (3)学力（得点率帯）
      // @TODO: ここの実装は4期でやる。なので今はセグメント3が設定してあるものは強制的に除外する
      const myPer = condition.segments.scorePer;
      items = items.filter(item => {
        if (item.segment3 === null) return true;

        const pers = item.segment3.split('|').map(val => parseInt(val, 10));

        for (let per of pers) {
          const from = per,
                to   = per === '90' ? 100 : per + 9;

          if (from <= myPer && myPer <= to) return true;
        }

        return false;
      });

      if (!items.length) return items;

      // ↓↓↓ 以下は必ず1件以上データがある ↓↓↓
      // ※以下はデータに対して破壊的変更が発生するのでクローンしておく
      items = JSON.parse(JSON.stringify(items));

      // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-286#comment-1189911463
      // ※表示順未設定のバナーにランダムで表示順を設定する
      //   この際「dispOrder」は表示順ではなく管理システムでのID的な項目になるので、
      //   データ読み込みの時に初期化済みの「order」値で決定する
      items.forEach(item => {
        if (item.order === null) {
          let ok = false;
          while (!ok) {
            const myDispOrder = Math.floor(Math.random() * items.length) + 1;
            if (!items.find(target => target.order === myDispOrder)) {
              item.order = myDispOrder;
              ok = true;
            }
          }
        }
      });

      // 表示順でソートしておく
      items.sort((a, b) => {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });

      // 複数種別の指定がある場合、最小公倍数になるまで複製して指定の種別の順番ごとに交互に並べる
      if (myConditions.type !== null && myConditions.type.length > 1) {
        const counts = [];
        const types = myConditions.type.map(type => {
          const children = items.filter(item => item.classId === type);
          const count    = children.length;

          if (count) counts.push(count);

          return {
            type    : type,
            children: children,
            count   : count,
          }
        }).filter(type => type.count > 0);

        if (types.length > 1) {
          const lcm = computeLcm(...counts);
          types.forEach(type => {
            const needs = lcm - type.count;
            for (let i = 0; i < needs; i++) {
              const clone = Object.assign({}, type.children[i % type.count]);
              type.children.push(clone);
            }
          });

          items = [];
          for (let i = 0; i < lcm; i++) {
            types.forEach(type => {
              items.push(type.children[i]);
            });
          }
        }
      }

      // 必要個数が指定されていて、かつデータが1件以上あって、かつ足りない時は
      // 足りるまで配列を複製する（表示回数の条件を揃えるために補填ではなく複製）
      if (condition.needs && items.length < condition.needs) {
        while(items.length < condition.needs) {
          items = items.concat(items, items);
        }
      }

      // ※複製されたアイテムが参照を共有している可能性があるのでJSONパースしなおしておく
      items = JSON.parse(JSON.stringify(items));

      // 全てのアイテムにインデックスをつける
      items.forEach((item, i) => {
        item.index = i;
      });

      const toDataUriPromiseList = [];
      for (let item of items) {
        for (let mq of mqJudgments) {
          const imgKey = `fileName_${mq}`;
          if (item[imgKey] === null) {
            toDataUriPromiseList.push(new Promise((resolve, reject) => {
              imageManager.toDataUri(item[`originFileName_${mq}`])
                .then(dataUri => {
                  item[imgKey] = dataUri;
                  return resolve();
                })
                .catch(reject);
            }));
          }
        }
      }
      if (toDataUriPromiseList.length) {
        await Promise.all(toDataUriPromiseList);
      }

      return items;
    },
  },

  actions: {
    ready() {
      return new Promise(resolve => {
        $ev.hasAndOn('init', resolve);
      });
    },


    load({commit, dispatch, getters, rootGetters, rootState, state}) {
      return new Promise((resolve, reject) => {
        const url = getters['jsonPath'];

        const onLoad = data => {
          const items = data.adlist || [];

          commit('setSiteId', data.siteId);

          // json値補正
          items.forEach(item => {

            // // 画像パスに設定がなければnullを挿入＆指定があれば絶対パスに変換
            // ['fileName_pc', 'fileName_sp'].forEach(key => {
            //   if (typeof item[key] !== 'string') {
            //     item[key] = null;
            //   } else if (!item[key].match(/^(http|\.|\/)/)) {
            //       item[key] = getters['dataPath'] + '/' + item[key];
            //   }
            // });

            // PC、SPのパラメータたちの準備
            ['pc', 'sp'].forEach(key => {

              // 画像URL周りの準備
              const imgKey = `fileName_${key}`;
              let originFileName = item[imgKey];
              if (typeof originFileName !== 'string') {
                originFileName = null;
              } else if (!originFileName.match(/^(http|\.|\/)/)) {
                originFileName = getters['dataPath'] + '/' + originFileName;
              }

              // 後でdata uriに変換するのでオリジンのキーをnullにしておく
              item[`originFileName_${key}`] = originFileName;
              item[imgKey] = null;

              // URLに指定がなければnullを挿入
              const urlKey = `url_${key}`;
              if (typeof item[urlKey] !== 'string') {
                item[urlKey] = null;
              }
            });

            // // URLに指定がなければnullを挿入
            // ['url_pc', 'url_sp'].forEach(key => {
            //   if (typeof item[key] !== 'string') {
            //     item[key] = null;
            //   }
            // });

            // blankWindow値にデフォルトを設定
            if (!item.blankWindow) {
              item.blankWindow = '_self';
            }

            // segment条件未設定であればnullを設定
            for (let i = 1; i < 11; i++) {
              const key = `segment${i}`;
              if (item[key] === undefined) item[key] = null;
            }

            // 表示期間値をユニックスタイムで保持
            ['From', 'To'].forEach(key => {
              const str   = item[`dispPeriod${key}`];
              const year  = parseInt(str.substr(0, 4), 10);
              const month = parseInt(str.substr(4, 2), 10) - 1;
              const day   = parseInt(str.substr(6, 2), 10);
              item[`_dispPeriod${key}`] = new Date(year, month, day).getTime();
            });

            // 表示順設定が未設定であればnullを設定
            item.dispOrder = item.dispOrder === undefined ? null : item.dispOrder;

            // ※上記「dispOrder」は実際には表示順ではなく管理システムのID的に利用される項目で、
            //   画面表示の際は表示枠ごとに常にランダムに表示順を決定する
            //   @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-286#comment-1189911463
            //   なので実際の表示順用に「order」値を初期化しておく
            item.order = null;
          });

          commit('setItems', items);
          return resolve(data);
        }

        const onLoadError = error => {
          return reject(new Error(error));
        }

        axios.get(url)
          .then(res => {
            const data = res.data;
            if (typeof data !== 'object') return onLoadError('広告設定ファイルのフォーマットが正しくありません。');
            return onLoad(data);
          })
          .catch(onLoadError);
      });
    },
    async sendLog({commit, dispatch, getters, rootGetters, rootState, state}, {type, item}) {

      // バナー設定ファイルで許可されているロケーション以外ではログ送信を行わない
      // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-133
      if (!rootGetters['banner/config/executionLogSend']) return;

      const params = {
        siteId   : state.siteId,
        id       : item.id,
        logType  : type,
        timestamp: Math.floor(new Date().getTime() / 1000),
      };

      ['typeId', 'classId'].forEach(key => {
        if (item[key]) params[key] = item[key];
      });

      const uibc = cookies.get('be_ad_net_userid');
      if (uibc) params.uibc = uibc;

      const safeLogUrl = rootGetters['banner/config/safeLogUrl'];

      try {
        await axios.get(rootGetters['banner/config/logUri'], {params: params});
      } catch(e) {
        console.warn(e);

        if (safeLogUrl) {
          axios.get(safeLogUrl, {params: params});
        }
      }
    },
  },

  mutations: {
    setSiteId(state, siteId) {
      state.siteId = siteId;
    },

    setItems(state, items = []) {
      state.items = items;
      $ev.emit('init');
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/modules/data.js